import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Card, DataTable } from '@shopify/polaris';

const propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
}

const defaultProps = {

}

const GeneralStatsCard = (props) => {
  return (
    <Card title={ props.title } >
      <DataTable
        rows={ props.rows }
        totals={['Total', props.total ]}
        headings={[ '', '',]}
        columnContentTypes={['text', 'numeric' ]}
      />
    </Card>
  )
};

GeneralStatsCard.propTypes = propTypes;
GeneralStatsCard.defaultProps = defaultProps;

export default GeneralStatsCard;